import React, { memo, useMemo, useState } from "react";
import { Card, CardBody, CardTitle, Col, ListGroup, Row } from "reactstrap";
import Notification from "./Notification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

const Notifications = memo(({ notifications = [] }) => {
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    if (!search) return notifications;
    const term = search.toLowerCase();
    return notifications.filter((n) => {
      const fullName = `${n.title || ""} ${n.first_name || ""} ${n.middle_name || ""} ${n.last_name || ""}`.toLowerCase();
      const id = String(n.case_id || "").toLowerCase();
      return fullName.includes(term) || id.includes(term);
    });
  }, [notifications, search]);

  return (
    <Card>
      <CardBody>
        <Row>
          <Col className="mt-0">
            <CardTitle tag="h5" className="mb-1">Notifications</CardTitle>
            <div>
              <input
                type="text"
                className="form-control w-50 form-control-sm"
                placeholder="Search by name or Case ID..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </Col>

          <Col className="col-auto">
            <div className="avatar">
              <div className="avatar-title rounded-circle bg-primary-dark">
                <FontAwesomeIcon icon={faBell} size="lg" />
              </div>
            </div>
          </Col>
        </Row>


        <div className="h-306 overflow-auto mt-2">
          {filtered.length === 0 && (
            <div className="p-4 d-flex justify-content-center align-items-center h-full">
              <h4>
                <FontAwesomeIcon icon={faBell} size="lg" /> No Notifications!
              </h4>
            </div>
          )}
          <ListGroup flush className="mr-2">
            {filtered.map((notification) => (
              <Notification
                key={notification.case_id}
                id={notification.case_id}
                title={notification.title}
                firstname={notification.first_name}
                middlename={notification.middle_name}
                lastname={notification.last_name}
              />
            ))}
          </ListGroup>
        </div>
      </CardBody>
    </Card>
  );
});

export default Notifications;
